import './NavigationToggle.scss.js';
import * as React from 'react';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { Icon } from '../Icon/Icon.js';
import { useId } from '../../utils/hooks/useId.js';

const { DoubleChevronLeft, DoubleChevronRight, MobileMenu, Cross } = VaiIcon;
const bem = Bem.create("vai-navigation-toggle");
function NavigationToggle({ open, onChange, dataTa, className, htmlId }) {
  const id = useId(htmlId, ["navigation toggle"]);
  return /* @__PURE__ */ React.createElement("button", {
    id: id.toString(),
    className: addClass(bem.block(), className),
    "data-ta": dataTa,
    "data-ta-status": open ? "open" : "closed",
    onClick: onChange
  }, /* @__PURE__ */ React.createElement(Icon, {
    className: bem.element("icon")("desktop"),
    name: open ? DoubleChevronLeft : DoubleChevronRight
  }), /* @__PURE__ */ React.createElement(Icon, {
    className: bem.element("icon")("mobile"),
    name: open ? Cross : MobileMenu
  }));
}
NavigationToggle.defaultProps = {
  dataTa: "vai-navigation-toggle"
};

export { NavigationToggle };
